import type { IPascoRepository, SearchPascoResult } from "@src/domain/pascos/repository/pasco_repository";
import type { PascoListItemDTO } from "../dto";
import { PascoDtoMapper } from "../mappers/pasco-dto.mapper";

/**
 * Use Case: Get Public PASCOs
 * Retrieves public PASCOs filtered by university
 */
export class GetPublicPascosUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    async execute(universityId?: string, skip?: number, limit?: number, filters?: { courseCode?: string; semester?: string; academicYear?: string }): Promise<{ pascos: PascoListItemDTO[]; total: number; hasMore: boolean }> {
        const result: SearchPascoResult = await this.pascoRepository.getPublicPascos({
            university_id: universityId,
            course_code: filters?.courseCode,
            semester: filters?.semester,
            academic_year: filters?.academicYear,
            skip,
            limit,
        });

        return {
            pascos: PascoDtoMapper.toListItemDTOArray(result.pascos),
            total: result.total,
            hasMore: result.hasMore,
        };
    }
}